export const TEXT: any = {
    benefithub_title: "Deeperks Admin"
}